import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, PaperClip } from 'components';
import { OperatorService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { GoogleMapsIcon } from 'assets/icons';

interface Props {
	onClose?: any;
	item?: any;
}

// @ts-ignore
const google = window.google;

class ModalViewClient extends React.Component<Props> {

	state = {
		item: this.props.item
	}
	
	render() {
		const { city } = this.state.item;
		const address = [city].filter((i: any) => i != null && i != '').join(' - ');

		return (
			<div id="modal-view-client">
				<div className="container-location">
					<h4>Datos</h4>
					<h3><strong>Cliente:</strong> { this.state.item?.full_name }</h3>
					<h3><strong>Teléfono:</strong> { this.state.item?.phone }</h3>
					<h3><strong>RIF / C.I.:</strong> { [Constants.DOCUMENT_TYPES.V,Constants.DOCUMENT_TYPES.E].indexOf(this.state.item?.document_type_id) != -1 ? this.state.item?.full_document : this.state.item?.full_tax_document }</h3>
					<h3><strong>Correo:</strong> { this.state.item?.email }</h3>
					{
						this.state.item?.addresses?.map((i: any) => {
							let address = '';
							
							if (i.state) {
								if (address) address += ' - ';
								address += i.state?.name;
							}

							if (i.city) {
								if (address) address += ' - ';
								address += i.city?.name;
							}

							if (i.municipality) {
								if (address) address += ' - ';
								address += i.municipality?.name;
							}

							if (i.address) {
								if (address) address += ' - ';
								address += i.address;
							}

							if (i.information) {
								if (address) address += ' - ';
								address += i.information;
							}

							if (i.indications) {
								if (address) address += ' - ';
								address += i.indications;
							}

							return (
								<div className="item-address">
									<img src={ GoogleMapsIcon } />
									<div>
										<p>{ address }</p>
									</div>
								</div>
							)
						})
					}
				</div>
				<div className="text-center">
					<Button type="button" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalViewClient;